module.exports = __webpack_public_path__ + "1bdf0e4361806b5e8e6da5be49e11154.pdf";